import AddressService from 'src/services/Address.service';
import DateTimeService from './DateTimeService';

const TransformService = {
  msToTime: (ms) => {
    if (ms === undefined) return '-';
    let seconds = Math.floor(ms / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(hours / 24);

    console.log('rohit check', seconds, minutes, hours, days);

    minutes -= hours * 60;
    hours -= days * 24;

    let output = `${minutes} min${minutes > 1 ? 's' : ''}`;

    if (hours === 0 && days === 0) return output;

    output = `${hours} hr${hours > 1 ? 's' : ''} ${output}`;

    if (days === 0) return output;

    output = `${days} day${days > 1 ? 's' : ''} ${output}`;

    return output;
  },

  msToTimeFormatted: (ms) => {
    if (ms === undefined) return '-';
    let seconds = Math.floor(ms / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds -= minutes * 60;
    minutes -= hours * 60;

    let output = `00:00:${seconds < 10 ? '0' : ''}${seconds}`;
    if (minutes === 0) return output;

    output = `00:${minutes < 10 ? '0' : ''}${minutes}:${
      seconds < 10 ? '0' : ''
    }${seconds}`;

    if (hours === 0) return output;

    output = `${hours < 10 ? '0' : ''}${hours}:${
      minutes < 10 ? '0' : ''
    }${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

    return output;
  },

  hrsToTime: (hrs) => {
    if (hrs === undefined) return '-';
    let minutes = Math.floor(hrs / 60);
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(hours / 24);

    minutes -= hours * 60;
    hours -= days * 24;

    let output = `${minutes} min${minutes > 1 ? 's' : ''}`;

    if (hours === 0 && days === 0) return output;

    output = `${hours} hr${hours > 1 ? 's' : ''} ${output}`;

    if (days === 0) return output;

    output = `${days} day${days > 1 ? 's' : ''} ${output}`;

    return output;
  },

  msToYearsDays: (ms) => {
    if (ms === undefined) return '-';
    let seconds = Math.floor(ms / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(hours / 24);
    let years = Math.floor(days / 365);
    days -= years * 365;

    if (days === 0) {
      if (years === 1) {
        return '1 year';
      }
      return `${years} years`;
    }
    return `${years} years ${days} days`;
  },

  mToKm: (m) => {
    if (m === undefined) return '-';
    return `${(m / 1000).toFixed(2)} km`;
  },

  dateTimeStringToDate: (dateTimeString) => {
    if (dateTimeString === undefined) return '-';
    return DateTimeService.getDateString(dateTimeString);
  },

  latLongToAddress: async (lat, long) => {
    if (lat === undefined || long === undefined) return '-';
    const data = await AddressService.get({
      latitude: lat,
      longitude: long
    });

    return data;
  },

  paiseToRupees: (paise) => {
    if (paise === undefined) return '-';
    return `₹${(paise / 100).toFixed(2)}`;
  }

  // TODO: voltage ,
};

export default TransformService;
